import React from "react";
import "./Shop_by_shapes.css";
import CommonHeadingAfterLine from "../../Common-Component/CommonHeadingAfterLine/CommonHeadingAfterLine";
import Shop_by_shapes_cards from "../../Common-Component/Shop_by_shapes_cards/Shop_by_shapes_cards";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function Shop_by_shapes({productdata}) {
  const slides = Array(9).fill(null); // Creates an array of 9 elements

  return (
    <section className="Shop_by_shapes">
      <div className="custom_container">
        <CommonHeadingAfterLine headingText={"All Product"} />

        <div className="Shop_by_shapes_cards_holder">
          <Swiper
            spaceBetween={40}
            slidesPerView={5}
            breakpoints={{
              0: {
                slidesPerView: 2.5,
                spaceBetween: 10,
              },
              420: {
                slidesPerView: 3.5,
                spaceBetween: 10,
              },
              485: {
                slidesPerView: 3.5,
                spaceBetween: 10,
              },
              640: {
                slidesPerView: 4.5,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 30,
              },
              1280: {
                slidesPerView: 5,
                spaceBetween: 40,
              },
            }}
          >
            {productdata.map((val, index) => (
              <SwiperSlide key={index}>
                <Shop_by_shapes_cards val={val}/>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Shop_by_shapes;
